import React from 'react'

export default function LinkNotFound() {
  return (
    <section className="ob-error">
      <h1 className="zb-heading2">Link Not Found</h1>

      <div className="zb-card">
        <div className="zb-card-body">Your search returned no links</div>
      </div>
    </section>
  )
}
